module.exports = __webpack_public_path__ + "img/property-valuation.b05d6162.jpg";